<script setup lang="ts">
import { RouterLink, useRoute } from 'vue-router'
import type { PortalModule, PortalNavItem } from './module-registry'
withDefaults(defineProps<{ modules: PortalModule[]; stacked?: boolean }>(), { stacked: false })
const route = useRoute()
function isActive(item: PortalNavItem): boolean {
  if (item.hash) return route.path === item.to && route.hash === item.hash
  if (route.hash) return false
  return item.exact ? route.path === item.to : route.path === item.to || route.path.startsWith(`${item.to}/`)
}
</script>

<template>
  <nav aria-label="主导航" class="app-navigation" :class="{ 'app-navigation--stacked': stacked }">
    <template v-for="mod in modules" :key="mod.key">
      <RouterLink v-for="item in mod.nav" :key="`${item.to}${item.hash ?? ''}`" :to="{ path: item.to, hash: item.hash }"
        class="app-navigation__link" :class="{ 'is-active': isActive(item) }" :aria-current="isActive(item) ? 'page' : undefined">
        <component :is="mod.icon" v-if="stacked" :size="17" :stroke-width="1.7" aria-hidden="true" />
        {{ item.label }}
      </RouterLink>
    </template>
  </nav>
</template>

<style scoped>
.app-navigation { display: flex; align-items: stretch; align-self: stretch; gap: 30px; }
.app-navigation__link { position: relative; display: flex; align-items: center; gap: 10px; color: var(--pf-text-secondary); font-size: 14px; white-space: nowrap; transition: color var(--pf-duration-fast); }
.app-navigation__link:hover, .app-navigation__link.is-active { color: var(--pf-accent); }
.app-navigation__link.is-active { font-weight: 600; }
.app-navigation__link.is-active::after { position: absolute; right: 4px; bottom: 0; left: 4px; height: 3px; border-radius: 3px 3px 0 0; background: var(--pf-accent); content: ''; }
.app-navigation--stacked { flex-direction: column; gap: 6px; padding: 24px 0; }
.app-navigation--stacked .app-navigation__link { min-height: 46px; padding: 12px; border-radius: var(--pf-radius-control); }
.app-navigation--stacked .is-active { background: var(--pf-accent-soft); }
.app-navigation--stacked .is-active::after { display: none; }
@media (max-width: 1100px) { .app-navigation { gap: 20px; } }
</style>
